module.exports = __webpack_public_path__ + "img/inquiry_pic.0dbcd511.jpg";